import * as app from 'actions/app';
import * as actions from 'actions/chat/bot';

const initialState = {
  started: false,
  conversation: undefined,
  userId: undefined,
  ended: false,
  caseComments: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.START:
      return { ...state, started: true,
        conversation: { ...action.conversation },
        userId: action.userId,
        caseComments: action.caseComments 
      };
    case actions.END:
      return { ...state, ended: true };
    case app.RESET:
      return { ...initialState };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./reducers/chat/bot.js